import { useDemoStore } from '../../pinia/index'
const store = useDemoStore()


const getApiUrl = () => {
    let api;
    if (store.context == 0) { //测试
        api = "http://d-api.files99.com/v2";
    } else if (store.context == 1) { //备用
        if (store.server == 'cn') { //中国
            api = 'https://cn-d-api-produce.files99.com/v2'
        } else if (store.server == 'de') { //德国
            api = 'https://de-d-api-produce.kernal.net/v2'
        } else if (store.server == 'usWest') { //美国西部
            api = 'https://us-d-api-produce.kernal.net/v2'
        } else if (store.server == 'br') { //巴西
            api = 'https://br-d-api-produce.kernal.net/v2'
        } else if (store.server == 'sg') { //新加坡
            api = 'https://sg-d-api-produce.kernal.net/v2'
        } else if (store.server == 'usEst') { //美国东部
            api = 'https://use-d.salesdeep.com/v2'
        }
    } else if (store.context == 2) { //生产
        if (store.server == 'cn') { //中国
            api = 'https://cn-d-api-produce.files99.com/v2'
        } else if (store.server == 'de') { //德国
            api = 'https://de-d.salesdeep.com/v2'
        } else if (store.server == 'usWest') { //美国西部
            api = 'https://us-d.salesdeep.com/v2'
        } else if (store.server == 'br') { //巴西
            api = 'https://br-d.salesdeep.com/v2'
        } else if (store.server == 'sg') { //新加坡
            api = 'https://sg-d.salesdeep.com/v2'
        } else if (store.server == 'usEst') {  //美国东部
            api = 'https://use-d.salesdeep.com/v2'
        }
    }
    return api
}


export default getApiUrl